export const buildSrcSet = (variants = []) => variants
    .map((variant) => `${variant.src} ${variant.width}w`)
    .join(', ');

export const getLargestVariant = (variants = []) => variants[variants.length - 1] || null;

export const getHeroPreloadProps = (image, sizes = '100vw') => {
    const variants = image?.variants?.avif || image?.variants?.webp || [];
    const largestVariant = getLargestVariant(variants);
    const srcSet = buildSrcSet(variants);

    return {
        href: largestVariant?.src || image?.src,
        imageSrcSet: srcSet || undefined,
        imageSizes: srcSet ? sizes : undefined,
    };
};
